import { TabMenuItem } from "./TabMenuItem";

export class TabMenu {
    customMenu?: any;

    menuItems?: TabMenuItem[] = [];
    activeMenuItem?: string;

    doNotShowTucked?: boolean;

    menuItemClicked?(tab: TabMenuItem): void;

    /**
     * Optional Back/Forward hook. TabComponent calls it when navigation resolves to the tab's
     * base URL (no `activemenu` query). The implementation should re-select its default state
     * (e.g. a preset workspace re-selects its default preset). When absent, TabComponent falls
     * back to clicking the first clickable sidebar item. May return a promise; TabComponent
     * awaits it so URL sync stays suppressed until the selection settles.
     */
    selectDefaultMenuItem?(): void | Promise<void>;

    /**
     * Optional Back/Forward hook. TabComponent calls it with the id from an `activemenu` query
     * when navigation carries one. The implementation owns resolving the id and updating its
     * active state, including ids that are not sidebar items (e.g. a dashboard opened via
     * "Browse all", resolved by fetching it). When absent, TabComponent falls back to
     * `getTabMenuItemByMenuItemId` + `menuItemClicked`. If both hooks are set, only the one
     * matching the current URL runs (this one when an `activemenu` query is present). May
     * return a promise; TabComponent awaits it so URL sync stays suppressed until it settles.
     */
    selectMenuItemById?(menuItemId: string): void | Promise<void>;

    public getTabMenuItemByMenuItemId(menuItemId: string, ignoreCase?: boolean): TabMenuItem {
        const tabMenuItem = this.getTabMenuItem(menuItemId, this.menuItems, ignoreCase);

        return tabMenuItem;
    }

    getTabMenuItem(menuItemId: string, items: TabMenuItem[], ignoreCase?: boolean): TabMenuItem {
        let tabMenuItem =
            ignoreCase === true
                ? items.find(
                      (x) => x.menuItemId && x.menuItemId.toLowerCase() === menuItemId.toLowerCase()
                  )
                : items.find((x) => x.menuItemId === menuItemId);

        if (!tabMenuItem) {
            items.forEach((item) => {
                if (item.children) {
                    if (!tabMenuItem) {
                        tabMenuItem = this.getTabMenuItem(menuItemId, item.children, ignoreCase);
                    }

                    if (tabMenuItem) {
                        return tabMenuItem;
                    }
                }
            });
        }

        return tabMenuItem;
    }
}
